import {LSWorkSessionKey} from "@/workSessions/constants";
export const workSessionStorageHelper = {
    async encodeAndStoreWorkSessionData(workSessionData){
        //Encode the session data for storing so users won't be able to fiddle with it.
        window.console.log('Encoding and SAVING VERIFIED SESSION');
        try{
            let encodedSession = btoa(JSON.stringify(workSessionData));
            await localStorage.setItem(LSWorkSessionKey, encodedSession);
            return true
        }catch(e){
            return false
        }

    },
    async clearWorkSessionData(){
        window.console.log('CLEARING SAVED SESSION DATA!!!!');
        await localStorage.removeItem(LSWorkSessionKey);
    },
    async decodeAndGetStoredWorkSessionData(){
        let storedData = await localStorage.getItem(LSWorkSessionKey)
        if (storedData) {
            window.console.log('STORED WORKSESSION FOUND');
            try {
                //Reverse encoding
                let objectString = atob(localStorage.getItem(LSWorkSessionKey))
                window.console.log('DECODED SESSION:');
                window.console.log(objectString);
                let $object = JSON.parse(objectString);
                window.console.log('JSON OBJECT : ');
                window.console.log($object);
                return $object;

            }catch (e) {
                window.console.log('GSWS - ERROR DURING PARSE')
                return null;
            }
        }else{
            window.console.log('GSWS - COULD NOT FIND')
            return null
        }
    }
}